"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplicateReferenceError = exports.UnknownReferenceError = exports.TaxMismatchError = exports.InvalidQuantityError = exports.InvalidPercentError = exports.InvalidDateError = exports.InvalidAmountError = exports.OrderingError = void 0;
// Erreurs typées du moteur (spec §3.2) : jamais un `throw new Error(...)`
// générique — un échec de calcul (montant, pourcentage, quantité, taxe,
// référence) doit pouvoir être distingué par son type, jusqu'à l'adaptateur
// v1 qui l'affiche en bannière plutôt que de rendre un total silencieux (F4).
class OrderingError extends Error {
    constructor(message) {
        super(message);
        this.name = new.target.name;
    }
}
exports.OrderingError = OrderingError;
class InvalidAmountError extends OrderingError {
}
exports.InvalidAmountError = InvalidAmountError;
// Horodatage ou fuseau invalide (éligibilité, R9) : le moteur ne consulte
// jamais l'horloge machine — une date sans fuseau explicite est une erreur.
class InvalidDateError extends OrderingError {
}
exports.InvalidDateError = InvalidDateError;
class InvalidPercentError extends OrderingError {
}
exports.InvalidPercentError = InvalidPercentError;
class InvalidQuantityError extends OrderingError {
}
exports.InvalidQuantityError = InvalidQuantityError;
class TaxMismatchError extends OrderingError {
}
exports.TaxMismatchError = TaxMismatchError;
class UnknownReferenceError extends OrderingError {
}
exports.UnknownReferenceError = UnknownReferenceError;
// Deux lignes de panier portant la même référence : le ciblage des promotions
// et des remises se fait par référence de ligne, une collision rendrait les
// montants ambigus (F4 — jamais de remise silencieusement rognée).
class DuplicateReferenceError extends OrderingError {
}
exports.DuplicateReferenceError = DuplicateReferenceError;
